import ParallaxObj from "./ParallaxObj"

class Parallax
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Parallax
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    console.log('Parallax')

    //パララックスオブジェクトに変換
    const _objects = []
    $('.js-parallax-obj').each(function(e){
      const obj = new ParallaxObj($(this))
      _objects.push(obj)
    })
    this.objects = _objects

    //スクロールのハンドリング
    $(window).scroll(this.onScroll.bind(this))
  }

  /**
   * スクロール
   */
  onScroll(e)
  {
    const scrollY = $(window).scrollTop()

    const len = this.objects.length
    for(let i=0; i<len; i++)
    {
      const obj = this.objects[i]
      obj.update(scrollY)
    }
  }
 
  // ---------------------------------------------------------------------------------------------------------
}

export default Parallax
